// the strings are from the marketing team
export const googleAnalyticsUrls = {
    bankwire_open: '/deposit/bankwire_open',

    skrill_open_amount: '/deposit/skrill_open_amount',
    skrill_pageout: '/deposit/skrill_pageout',

    neteller_open_amount: '/deposit/neteller_open_amount',
    neteller_pageout: '/deposit/neteller_pageout',

    sticpay_open_amount: '/deposit/sticpay_open_amount',
    sticpay_pageout: '/deposit/sticpay_pageout',

    sticpay_local_open_amount: '/deposit/sticpay_local_open_amount',
    sticpay_local_pageout: '/deposit/sticpay_local_pageout',

    trust_open_amount: '/deposit/trust_open_amount',
    trust_pageout: '/deposit/trust_pageout',

    thunderxpay_open_amount: '/deposit/thunderxpay_open_amount',
    thunderxpay_pageout: '/deposit/thunderxpay_pageout',

    credit_card_step1: '/deposit/credit_card_step1_amount',
    credit_card_step2: '/deposit/credit_card_step2_cardnumber',
    credit_card_step3: '/deposit/credit_card_step3_pageout',

    bitcoin_open: '/deposit/bitcoin_open',

    local_payment_open_kr: '/deposit/local_payment_subscriber_step1_open_kr',
    local_payment_subscriber_pageout_kr: '/deposit/local_payment_subscriber_step2_open_kr_pageout',
    local_payment_unsubscribed_open_kr: '/deposit/local_payment_unsubscribed_open_kr',


    local_bankwire_open_jp: '/deposit/local_bankwire_open_jp',

    local_domestic_step1_vn: '/deposit/local_domestic_step1_open_vn',
    local_domestic_success_vn: '/deposit/success/domestic/local_step2_vn',

    local_domestic_step1_th: '/deposit/local_domestic_step1_open_th',
    local_domestic_success_th: '/deposit/success/domestic/local_step2_th',

    bank_transfer_step1_vn: '/deposit/local_bank_transfer_step1_open_vn',
    bank_transfer_success_vn: '/deposit/success/local_bank_transfer_step2_vn',

    payme_step1_vn: '/deposit/payme_step1_open_vn',
    payme_success_vn: '/deposit/success/payme_step2_vn',

    payda_open_amount: '/deposit/payda_open_amount',
    payda_pageout: '/deposit/payda_pageout',

    mobile_open_th: '/deposit/mobile_bank_open_th',
    mobile_success_th: '/deposit/success/mobile_th',

    simple_account_open: '/open_account/simple_account_open',
    simple_account_completion: '/open_account/simple_account_completion',

    land_prime_open: '/register',
    land_prime_completion: '/register/land_prime_completion',

    live_account_step1: '/open_account/live_account_step1_open',
    live_account_step2: '/open_account/live_account_step2_information',
    live_account_step3: '/open_account/live_account_step3_customeragree',
    live_account_step4: '/open_account/live_account_step4_dangerous',
    live_account_step5: '/open_account/live_account_step5_completion',
};

export function sendGaPageviewEvent(url) {
    if(window.ciEnv === 'uk-eweb')
    {
        ga('send', 'pageview', url);
    }
}